import { styled } from 'styled-components';

import AlertThresholdsForm from 'src/components/AlertSettingsComponents/AlertThresholdsForm';

export const StyledAlertThresholdsForm = styled(AlertThresholdsForm)`
  column-gap: 2rem;
`;
